<main id="perguntasFrequentes" class="container">
  <h1 class="title text-center">Perguntas Frequentes</h1>
  <app-barra-busca
    [componenteRef]="componenteRef"
    (inputEvent)="recebeuInput($event)"
  ></app-barra-busca>
  <p *ngIf="perguntas && realizouBusca" class="text-center results">
    Sua pesquisa retornou {{ perguntas.length }} resultados
  </p>
  <p *ngIf="!perguntas" class="text-center results">
    Desculpe, não encontramos nenhum resultado compatível com sua busca.
  </p>

  <ng-container *ngIf="perguntas">
    <ul>
      <li class="card bg-color-white contrast-border" *ngFor="let pergunta of perguntas">
        <app-card
          [titulo]="pergunta.pergunta"
          [texto]="pergunta.resposta"
          [tipo]="componenteRef"
        ></app-card>
      </li>
    </ul>

    <ng-container *ngIf="totalPaginas">
      <app-paginacao
        [paginaAtual]="paginaAtual"
        [totalPaginas]="totalPaginas"
        (mudouPagina)="onPaginaSelecionada($event)"
      ></app-paginacao>
    </ng-container>
  </ng-container>
</main>
